import { render, staticRenderFns } from "./QuantitySelector26.vue?vue&type=template&id=a6f89fe8&scoped=true"
import script from "./QuantitySelector26.vue?vue&type=script&lang=js"
export * from "./QuantitySelector26.vue?vue&type=script&lang=js"
import style0 from "./QuantitySelector26.vue?vue&type=style&index=0&id=a6f89fe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f89fe8",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fproduct-details-26%2Fsubcomponents%2Fquantity-selector-26%2FQuantitySelector26.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports